/**
 * Перечень серверных команд для CollectionWidget.
 * Используется при вызовах из CollectionItemsController и при автоподгрузке.
 */
var CollectionServerCmd;
(function (CollectionServerCmd) {
    /** Удалить выбранные элементы (→ "delete-rows") */
    CollectionServerCmd["delete_rows"] = "delete-rows";
    /** Перезагрузить содержимое коллекции без реинициализации виджета */
    CollectionServerCmd["reloadContent"] = "reloadContent";
    /** Автоматическая подгрузка следующей страницы (→ "autoload") */
    CollectionServerCmd["autoload"] = "autoload";
})(CollectionServerCmd || (CollectionServerCmd = {}));

export { CollectionServerCmd };
